import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const ProgressSpinner = () => {
  return (
    <Box sx={{ 
      mt: 10,
      display: 'flex',
    }}>
      <CircularProgress size="6rem"/>
    </Box>
  );
}

export default ProgressSpinner
